import { Button } from '@libs/react/ui';
import { ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

export function Start(props: Props) {
  return (
    <div>
      <ul>
        <li>
          <Button href="http://localhost:4200/client/carta">Carta</Button>
        </li>
      </ul>
    </div>
  );
}
